import brokerUpstox from '../resources/brand/broker-upstox.svg';
import brokerUpstoxDark from '../resources/brand/broker-upstox-dark.svg';
import broker5paisa from '../resources/brand/broker-5paisa.png';
import broker5paisaDark from '../resources/brand/broker-5paisa-dark.png';
import brokerZerodha from '../resources/brand/broker-zerodha.svg';
import brokerZerodhaDark from '../resources/brand/broker-zerodha-dark.svg';
import brokerIIFL from '../resources/brand/broker-iifl.png';
import brokerIIFLDark from '../resources/brand/broker-iifl-dark.png';
import brokerFinvasia from '../resources/brand/broker-finvasia.png';
import brokerFinvasiaDark from '../resources/brand/broker-finvasia-dark.png';
import brokerBigul from '../resources/brand/broker-bigul.png';
import brokerBigulDark from '../resources/brand/broker-bigul-dark.png';
import brokerTradejini from '../resources/brand/broker-tradejini.png';
import brokerTradejiniDark from '../resources/brand/broker-tradejini-dark.png';
import brokerFyers from '../resources/brand/broker-fyers.png';
import brokerFyersDark from '../resources/brand/broker-fyers-dark.png';
import brokerAcAgarwal from '../resources/brand/broker-ac-agarwal.png';
import brokerAcAgarwalDark from '../resources/brand/broker-ac-agarwal-dark.png';
import brokerBigulPro from '../resources/brand/broker-bigul-pro.png';
import brokerBigulProDark from '../resources/brand/broker-bigul-pro-dark.png';
import brokerJainamduck from '../resources/brand/broker-jainamduck.png';
import brokerJainamduckDark from '../resources/brand/broker-jainamduck-dark.png';
import brokerFlatTrade from '../resources/brand/broker-flattrade.png';
import brokerFlatTradeDark from '../resources/brand/broker-flattrade-dark.png';
import brokerKotak from '../resources/brand/broker-kotak.png';
import brokerKotakDark from '../resources/brand/broker-kotak-dark.png';
import brokerMotilalOswal from '../resources/brand/broker-motilaloswal.png';
import brokerMotilalOswalDark from '../resources/brand/broker-motilaloswal-dark.png';
import brokerJainamXtsA from '../resources/brand/broker-jainamxtsa.png';
import brokerJainamXtsADark from '../resources/brand/broker-jainamxtsa-dark.png';
import brokerCrkothari from '../resources/brand/broker-crkothari.png';
import brokerCrkothariADark from '../resources/brand/broker-crkothari-dark.png';
import brokerMastertrustkambala from '../resources/brand/broker-mastertrustkambala.png';
import brokerMastertrustkambalaDark from '../resources/brand/broker-mastertrustkambala-dark.png';
import brokerSharekhan from '../resources/brand/broker-sharekhan.png';
import brokerSharekhanDark from '../resources/brand/broker-sharekhan-dark.png';
import brokerTradejini2 from '../resources/brand/broker-tradejini2.png';
import brokerTradejini2Dark from '../resources/brand/broker-tradejini2-dark.png';
import brokerAliceblue from '../resources/brand/broker-aliceblue.png';
import brokerAliceblueDark from '../resources/brand/broker-aliceblue-dark.png';
import brokerDhan from '../resources/brand/broker-dhan.png';
import brokerDhanDark from '../resources/brand/broker-dhan-dark.png';
import brokerIndiabulls from '../resources/brand/broker-indiabulls.png';
import brokerIndiabullsDark from '../resources/brand/broker-indiabulls-dark.png';
import brokerNirmalbang from '../resources/brand/broker-nirmalbang.png';
import brokerNirmalbangDark from '../resources/brand/broker-nirmalbang-dark.png';
import brokerRikhav from '../resources/brand/broker-rikhav.png';
import brokerRikhavDark from '../resources/brand/broker-rikhav-dark.png';
import brokerArham from '../resources/brand/broker-arham.png';
import brokerArhamDark from '../resources/brand/broker-arham-dark.png';
import brokerAns from '../resources/brand/broker-ans.png';
import brokerAnsDark from '../resources/brand/broker-ans-dark.png';
import brokerShareindia from '../resources/brand/broker-shareindia.png';
import brokerShareindiaDark from '../resources/brand/broker-shareindia-dark.png';
import brokerZebu from '../resources/brand/broker-zebu.png';
import brokerZebuDark from '../resources/brand/broker-zebu-dark.png';
import brokerFirstock from '../resources/brand/broker-firstock.png';
import brokerFirstockDark from '../resources/brand/broker-firstock-dark.png';
import brokerGroww from '../resources/brand/broker-groww.png';
import brokerGrowwDark from '../resources/brand/broker-groww-dark.png';
import brokerAngel from '../resources/brand/broker-angel.png';
import brokerAngelDark from '../resources/brand/broker-angel-dark.png';
import brokeRmoney from '../resources/brand/broker-rmoney.png';
import brokeRmoneyDark from '../resources/brand/broker-rmoney-dark.png';
import brokeForwardTesting from '../resources/brand/broker-forward-testing.png';
import brokeForwardTestingDark from '../resources/brand/broker-forward-testing-dark.png';

export const brokersList = [
  {
    name: 'upstox',
    img: brokerUpstox,
    imgDark: brokerUpstoxDark,
    imgStyles: {
      width: '109px',
      height: '30px',
    },
    video: 'https://www.youtube.com/watch?v=EFNYqq-AOAE',
    documentLink: 'https://quantiply.tech/documentation/broker-setup/upstox/',
    market: ['NSE', 'BSE'],
  },
  {
    name: 'zerodha',
    img: brokerZerodha,
    imgDark: brokerZerodhaDark,
    imgStyles: {
      width: '121px',
    },
    video: 'https://www.youtube.com/watch?v=OZLbnDrYab4',
    documentLink: 'https://quantiply.tech/documentation/broker-setup/zerodha/',
  },
  {
    name: 'iifl',
    img: brokerIIFL,
    imgDark: brokerIIFLDark,
    imgStyles: {
      width: '140px',
    },
    video: 'https://www.youtube.com/watch?v=zHFV0zEayx0',
    documentLink: 'https://quantiply.tech/documentation/broker-setup/iifl/',
  },
  {
    name: 'angel',
    img: brokerAngel,
    imgDark: brokerAngelDark,
    imgStyles: {
      width: '140px',
    },
    video: 'https://www.youtube.com/watch?v=luzR_N0u4gA',
    accentColorText: '#1D76BB',
    accentColorBg: '#1D76BB',
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/angel-one/',
  },
  {
    name: 'finvasia',
    img: brokerFinvasia,
    imgDark: brokerFinvasiaDark,
    imgStyles: {
      width: '121px',
    },
    accentColorText: '#db583e',
    accentColorBg: '#db583e',
  },
  {
    name: 'bigul',
    img: brokerBigul,
    imgDark: brokerBigulDark,
    imgStyles: {
      width: '100px',
    },
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/bigul-by-bonanza/',
  },
  {
    name: 'tradejini',
    img: brokerTradejini,
    imgDark: brokerTradejiniDark,
    imgStyles: {
      width: '118px',
    },
    accentColorText: '#06a77d',
    accentColorBg: '#06a77d',
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/tradejini/',
  },
  {
    name: 'fyers',
    img: brokerFyers,
    imgDark: brokerFyersDark,
    imgStyles: {
      width: '85px',
    },
    documentLink: 'https://quantiply.tech/documentation/broker-setup/fyers/',
  },
  {
    name: '5paisa',
    img: broker5paisa,
    imgDark: broker5paisaDark,
    imgStyles: {
      height: '30px',
    },
    documentLink: 'https://quantiply.tech/documentation/broker-setup/5-paisa/',
  },
  {
    name: 'acagarwal',
    img: brokerAcAgarwal,
    imgDark: brokerAcAgarwalDark,
    imgStyles: {
      width: '130px',
    },
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/ac-agarwal/',
  },
  {
    name: 'bigul-pro',
    img: brokerBigulPro,
    imgDark: brokerBigulProDark,
    imgStyles: {
      width: '120px',
    },
    documentLink: false,
  },
  {
    name: 'jainamduck',
    img: brokerJainamduck,
    imgDark: brokerJainamduckDark,
    imgStyles: {
      width: '120px',
    },
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/jainam-duck/',
  },
  {
    name: 'flattrade',
    img: brokerFlatTrade,
    imgDark: brokerFlatTradeDark,
    imgStyles: {
      width: '120px',
    },
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/flattrade/',
  },
  {
    name: 'kotak',
    img: brokerKotak,
    imgDark: brokerKotakDark,
    imgStyles: {
      width: '118px',
    },
    accentColorText: '#2763b8',
    accentColorBg: '#2763b8',
  },
  {
    name: 'motilaloswal',
    img: brokerMotilalOswal,
    imgDark: brokerMotilalOswalDark,
    imgStyles: {
      width: '140px',
    },
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/motilal-oswal/',
  },
  {
    name: 'iifl2',
    img: brokerIIFL,
    imgDark: brokerIIFLDark,
    imgStyles: {
      width: '90px',
    },
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/iifl-v2-cdc/',
  },
  {
    name: 'jainamxtsa',
    img: brokerJainamXtsA,
    imgDark: brokerJainamXtsADark,
    imgStyles: {
      width: '120px',
    },
  },
  {
    name: 'jainamxtsb',
    img: brokerJainamXtsA,
    imgDark: brokerJainamXtsADark,
    imgStyles: {
      width: '120px',
    },
  },
  {
    name: 'jainamxtsd',
    img: brokerJainamXtsA,
    imgDark: brokerJainamXtsADark,
    imgStyles: {
      width: '120px',
    },
  },
  {
    name: 'crkothari',
    img: brokerCrkothari,
    imgDark: brokerCrkothariADark,
    imgStyles: {
      width: '68px',
    },
  },
  {
    name: 'jainamsred',
    img: brokerJainamXtsA,
    imgDark: brokerJainamXtsADark,
    imgStyles: {
      width: '120px',
    },
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/jainam-xts-retail/',
  },
  {
    name: 'jainamretail',
    img: brokerJainamXtsA,
    imgDark: brokerJainamXtsADark,
    imgStyles: {
      width: '120px',
    },
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/jainam-xts-retail/',
  },
  {
    name: 'jainamxtsc',
    img: brokerJainamXtsA,
    imgDark: brokerJainamXtsADark,
    imgStyles: {
      width: '120px',
    },
  },
  {
    name: 'mastertrustkambala',
    img: brokerMastertrustkambala,
    imgDark: brokerMastertrustkambalaDark,
    imgStyles: {
      width: '130px',
    },
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/master-trust/',
  },
  {
    name: 'sharekhan',
    img: brokerSharekhan,
    imgDark: brokerSharekhanDark,
    imgStyles: {
      width: '140px',
    },
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/sharekhan/',
  },
  {
    name: 'tradejinicubeplus',
    img: brokerTradejini2,
    imgDark: brokerTradejini2Dark,
    imgStyles: {
      width: '150px',
    },
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/tradejini-cube-plus/',
  },
  {
    name: 'aliceblue',
    img: brokerAliceblue,
    imgDark: brokerAliceblueDark,
    imgStyles: {
      width: '120px',
    },
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/alice-blue/',
  },
  {
    name: 'dhan',
    img: brokerDhan,
    imgDark: brokerDhanDark,
    imgStyles: {
      width: '120px',
    },
    documentLink: 'https://quantiply.tech/documentation/broker-setup/dhan/',
  },
  {
    name: 'kotak-neo',
    img: brokerKotak,
    imgDark: brokerKotakDark,
    imgStyles: {
      width: '118px',
    },
    accentColorText: '#2763b8',
    accentColorBg: '#2763b8',
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/kotak-neo-totp/',
  },
  {
    name: 'kotak-neo-v2',
    img: brokerKotak,
    imgDark: brokerKotakDark,
    imgStyles: {
      width: '118px',
    },
    accentColorText: '#2763b8',
    accentColorBg: '#2763b8',
  },
  {
    name: 'jainamdbd',
    img: brokerJainamXtsA,
    imgDark: brokerJainamXtsADark,
    imgStyles: {
      width: '120px',
    },
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/jainam-xts-retail/',
  },
  {
    name: 'indiabulls',
    img: brokerIndiabulls,
    imgDark: brokerIndiabullsDark,
    imgStyles: {
      width: '124px',
    },
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/indiabulls-xts/',
  },
  {
    name: 'rikhav',
    img: brokerRikhav,
    imgDark: brokerRikhavDark,
    imgStyles: {
      width: '120px',
    },
  },
  {
    name: 'ans',
    img: brokerAns,
    imgDark: brokerAnsDark,
    imgStyles: {
      width: '140px',
    },
  },
  {
    name: 'arham',
    img: brokerArham,
    imgDark: brokerArhamDark,
    imgStyles: {
      width: '170px',
    },
  },
  {
    name: 'shareindia',
    img: brokerShareindia,
    imgDark: brokerShareindiaDark,
    imgStyles: {
      width: '150px',
    },
  },
  {
    name: 'zebu',
    img: brokerZebu,
    imgDark: brokerZebuDark,
    imgStyles: {
      width: '110px',
    },
    accentColorText: '#0037b7',
    accentColorBg: '#0037b7',
    documentLink: 'https://quantiply.tech/documentation/broker-setup/zebu/',
  },
  {
    name: 'zebuxtsretail',
    img: brokerZebu,
    imgDark: brokerZebuDark,
    imgStyles: {
      width: '110px',
    },
    accentColorText: '#0037b7',
    accentColorBg: '#0037b7',
  },
  {
    name: 'iifl-markets',
    img: brokerIIFL,
    imgDark: brokerIIFLDark,
    imgStyles: {
      width: '90px',
    },
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/iifl-markets-new/',
  },
  {
    name: 'firstock',
    img: brokerFirstock,
    imgDark: brokerFirstockDark,
    imgStyles: {
      width: '120px',
    },
  },
  {
    name: 'group-share-india-pro',
    img: brokerShareindia,
    imgDark: brokerShareindiaDark,
    imgStyles: {
      width: '150px',
    },
  },
  {
    name: 'groww',
    img: brokerGroww,
    imgDark: brokerGrowwDark,
    imgStyles: {
      width: '130px',
    },
    documentLink: 'https://quantiply.tech/documentation/broker-setup/groww/',
  },
  {
    name: 'rmoney',
    img: brokeRmoney,
    imgDark: brokeRmoneyDark,
    imgStyles: {
      width: '125px',
    },
    documentLink:
      'https://quantiply.tech/documentation/broker-setup/r-money-xts/',
  },
  {
    name: 'jainam-multitrade',
    img: brokerJainamXtsA,
    imgDark: brokerJainamXtsADark,
    imgStyles: {
      width: '120px',
    },
  },
  {
    name: 'shareindia-pro-v0',
    img: brokerShareindia,
    imgDark: brokerShareindiaDark,
    imgStyles: {
      width: '150px',
    },
  },
  {
    name: 'shareindia-pro-v1',
    img: brokerShareindia,
    imgDark: brokerShareindiaDark,
    imgStyles: {
      width: '150px',
    },
  },
  {
    name: 'shareindia-pro-v2',
    img: brokerShareindia,
    imgDark: brokerShareindiaDark,
    imgStyles: {
      width: '150px',
    },
  },
  {
    name: 'shareindia-pro-v3',
    img: brokerShareindia,
    imgDark: brokerShareindiaDark,
    imgStyles: {
      width: '150px',
    },
  },
  {
    name: 'shareindia-pro-v4',
    img: brokerShareindia,
    imgDark: brokerShareindiaDark,
    imgStyles: {
      width: '150px',
    },
  },
  {
    name: 'shareindia-pro-v5',
    img: brokerShareindia,
    imgDark: brokerShareindiaDark,
    imgStyles: {
      width: '150px',
    },
  },
  {
    name: 'shareindia-pro-v6',
    img: brokerShareindia,
    imgDark: brokerShareindiaDark,
    imgStyles: {
      width: '150px',
    },
  },
  {
    name: 'shareindia-pro-v7',
    img: brokerShareindia,
    imgDark: brokerShareindiaDark,
    imgStyles: {
      width: '150px',
    },
  },
  {
    name: 'shareindia-pro-v8',
    img: brokerShareindia,
    imgDark: brokerShareindiaDark,
    imgStyles: {
      width: '150px',
    },
  },
  {
    name: 'shareindia-pro-v9',
    img: brokerShareindia,
    imgDark: brokerShareindiaDark,
    imgStyles: {
      width: '150px',
    },
  },
  {
    name: 'shareindia-pro-v10',
    img: brokerShareindia,
    imgDark: brokerShareindiaDark,
    imgStyles: {
      width: '150px',
    },
  },
  {
    name: 'forward-testing',
    img: brokeForwardTesting,
    imgDark: brokeForwardTestingDark,
    imgStyles: {
      width: '170px',
    },
  },
  {
    name: 'nirmalbang',
    img: brokerNirmalbang,
    imgDark: brokerNirmalbangDark,
    imgStyles: {
      width: '140px',
    },
  },
  {
    name: 'rikhavxtsretail',
    img: brokerRikhav,
    imgDark: brokerRikhavDark,
    imgStyles: {
      width: '120px',
    },
  },
  {
    name: 'shareindiaxtsretail',
    img: brokerShareindia,
    imgDark: brokerShareindiaDark,
    imgStyles: {
      width: '150px',
    },
  },
  {
    name: 'zebu-xts-pro',
    img: brokerZebu,
    imgDark: brokerZebuDark,
    imgStyles: {
      width: '110px',
    },
    accentColorText: '#0037b7',
    accentColorBg: '#0037b7',
  },
  {
    name: 'jainamaar',
    img: brokerJainamXtsA,
    imgDark: brokerJainamXtsADark,
    imgStyles: {
      width: '120px',
    },
  },
  {
    name: 'jainam-multitrade-delta-2',
    img: brokerJainamXtsA,
    imgDark: brokerJainamXtsADark,
    imgStyles: {
      width: '120px',
    },
  },
];
